import React from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {ListItemText} from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import { handleOpenAmazonConnect } from "redux/actions/customers/customersAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export const TabsNavigationLink = ({ prop, navLinkClasses, innerNavLinkClasses, itemIcon, collapseItemMini, rtlActive, itemText, collapseItemText, cx }) => {
  const {rules} = useSelector(({login}) => login)
  const {location} = useHistory()
  const dispatch = useDispatch();
  const handleClick = () => {
    rules.includes( 'CUSTOMER-CONNECT') && !location.pathname.includes('unidades_menu') && dispatch(handleOpenAmazonConnect(false));
  };

  return (
    <NavLink
      to={prop.layout + prop.path}
      className={cx(
        { [navLinkClasses]: prop.icon !== undefined },
        { [innerNavLinkClasses]: prop.icon === undefined }
      )}
      onClick={handleClick} // Llama a la función handleClick al hacer clic en el NavLink
    >
      {prop.icon !== undefined ? (
        typeof prop.icon === "string" ? (
          <Icon className={itemIcon}>{prop.icon}</Icon>
        ) : (
          <prop.icon className={itemIcon} />
        )
      ) : (
        <span className={collapseItemMini}>
          {rtlActive ? prop.rtlMini : prop.mini}
        </span>
      )}
      <ListItemText
        primary={rtlActive ? prop.rtlName : prop.name}
        disableTypography={true}
        className={cx(
          { [itemText]: prop.icon !== undefined },
          { [collapseItemText]: prop.icon === undefined }
        )}
      />
    </NavLink>
  );
};

